/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources/test_connection" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSourcesTestConnectionCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiSourcesTestConnectionProps,
  IntegrationsDirectCdiSourcesTestConnectionResult,
} from "./types";

export const postIntegrationsDirectCdiSourcesTestConnection = reactQueryMutationAdapter(
  integrationsDirectCdiSourcesTestConnectionCacheKeys,
  (
    props: PostIntegrationsDirectCdiSourcesTestConnectionProps
  ): Promise<IntegrationsDirectCdiSourcesTestConnectionResult> => {
    // manipulate props here as needed { partner_name, param2, param3 }

    return fetch("/integrations/direct/cdi/sources/test_connection", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
